import PaymentSuccess from "@/containers/Modals/PaymentSuccess";
import UpsaleModals from "@/containers/PlanModal/UpsaleModals";

import MainNavigation from "../MainNavigationNew";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@components/ui/sidebar";
import { cn } from "@/lib/utils";
import Logo from "@components/ui/logo";

const MobileNavigation = () => {
  return (
    <div className="sticky top-0 z-5 flex items-center justify-between p-4 bg-(--menu-background) md:hidden">
      <Logo width={80} />
      <SidebarTrigger />
    </div>
  );
};

const Layout = ({
  children,
  mainClassName = "",
}: {
  children: React.ReactNode;
  mainClassName?: string;
}) => {
  return (
    <>
      <SidebarProvider
        style={
          {
            "--header-height": "calc(var(--spacing) * 13)",
          } as React.CSSProperties
        }
      >
        <MainNavigation />
        <SidebarInset className={cn("pb-27 @container/main", mainClassName)}>
          <MobileNavigation />
          {children}
        </SidebarInset>
      </SidebarProvider>

      <PaymentSuccess />
      <UpsaleModals />
    </>
  );
};

export default Layout;
